import * as React from 'react'

const IconBrandEdu = (props) => (
  <svg
    width={32}
    height={32}
    viewBox='0 0 32 32'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <defs>
      <path id='icon-brand-edu_svg__a' d='M0 0h32v32H0z' />
      <path id='icon-brand-edu_svg__c' d='M0 0h26v25H0z' />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <mask id='icon-brand-edu_svg__b' fill='#fff'>
        <use xlinkHref='#icon-brand-edu_svg__a' />
      </mask>
      <path
        d='M26.092 32H5.907A5.907 5.907 0 0 1 0 26.093V5.908A5.908 5.908 0 0 1 5.907 0h20.185A5.909 5.909 0 0 1 32 5.908v20.185A5.908 5.908 0 0 1 26.092 32'
        fill='#FFF'
        mask='url(#icon-brand-edu_svg__b)'
      />
      <g transform='translate(3 4)'>
        <path
          d='M13.782 10.776c-1.16 0-2.104.974-2.104 2.172 0 1.2.945 2.176 2.104 2.176 1.16 0 2.103-.976 2.103-2.176 0-1.198-.944-2.172-2.103-2.172m-7.546.025c-1.235 0-2.238.975-2.238 2.175v.028l3.974-1.4a2.26 2.26 0 0 0-1.736-.803'
          fill='#00B2E3'
        />
        <mask id='icon-brand-edu_svg__d' fill='#fff'>
          <use xlinkHref='#icon-brand-edu_svg__c' />
        </mask>
        <path
          d='M24.798 13.241c0 1.82-1.49 3.299-3.321 3.299v-.001c-1.832 0-3.322-1.48-3.322-3.299v-3.103c0-.4.319-.726.71-.726a.72.72 0 0 1 .712.726v3.103c0 1.017.852 1.844 1.9 1.844s1.902-.827 1.902-1.844v-3.1c0-.4.317-.728.709-.728.391 0 .71.329.71.81v3.019zm-7.492-.292c0 2-1.58 3.63-3.524 3.63-1.942 0-3.523-1.63-3.523-3.63 0-2.002 1.581-3.63 3.523-3.63a3.43 3.43 0 0 1 2.103.721V7.295c0-.402.317-.727.71-.727a.72.72 0 0 1 .71.727v5.654zm-7.653-.63a.715.715 0 0 1-.407.376L4.511 14.36c.422.5 1.052.79 1.724.79.699 0 1.347-.308 1.776-.847a.699.699 0 0 1 .997-.106c.304.253.35.71.105 1.023a3.648 3.648 0 0 1-2.878 1.386c-2.017 0-3.659-1.628-3.659-3.629 0-2.003 1.642-3.63 3.66-3.63 1.543 0 2.927.968 3.446 2.41a.72.72 0 0 1-.03.563zm3.946-12.32H.63c-.645 0-.87.877-.31 1.203l.67.39L2.996 2.76c1.426.886 1.047 2.087.735 2.676a12.674 12.674 0 0 0-2.125 7.543c.235 6.456 5.342 11.726 11.643 12.009 6.963.312 12.71-5.356 12.751-12.411C26.04 5.61 20.4 0 13.6 0z'
          fill='#00B2E3'
          mask='url(#icon-brand-edu_svg__d)'
        />
      </g>
    </g>
  </svg>
)

export default IconBrandEdu
